/**
 * A card drawn from a lesson, presented as a regular reading in front of the
 * Mystic (Chris, 2026-10-28): the Mystic's portrait in the top pane, the
 * opener, the picker, the card settling into its panel, the reading writing
 * in, then the chips. The pure rules of it; the page and the chat do the rest.
 */

/** The card panel's width, and its chips' (about 640-720 at desktop). */
export const LESSON_PANEL_MAX = 680
/** On a phone the panel is full width with this gutter each side. */
export const LESSON_PANEL_GUTTER = 16
/** How long the opener is on its own before the picker comes up. */
export const OPENER_BEAT_MS = 1500
/** The Mystic steps back (fades) before the deck takes the pane. */
export const PRESENCE_LEAVE_MS = 300
/** "Get the full reading": the chips fade before the turn goes. */
export const CHIPS_LEAVE_MS = 260

export function chipsLeaveMs ({ reduced = false } = {}) {
  return reduced ? 0 : CHIPS_LEAVE_MS
}

/**
 * The top pane's share. Before the card (the opener and the picker) it is the
 * picker's own split, so the deck arriving never moves the divider. With the
 * card down and on its own (2026-10-28) the Mystic is larger, with the line
 * of where it came from under the portrait: sitting in front of the Mystic.
 * Once the conversation opens (Go deeper), or in a talk, the Mystic sits over
 * the conversation, as during a regular reading's interview.
 */
export function lessonTopPct ({ how = '', carded = false, deeper = false, wide = true } = {}) {
  if (how === 'draw' && !carded) return wide ? 51 : 50
  if (how === 'draw' && !deeper) return wide ? 37 : 29
  return wide ? 30 : 24
}

/** What is left of the opener's beat (0: the picker may come up now). */
export function openerBeatLeft ({ openerAt = 0, now = 0, reduced = false } = {}) {
  if (reduced || !openerAt) return 0
  return Math.max(0, openerAt + OPENER_BEAT_MS - now)
}

/** The reading writes in at about a line a quarter-second, never rushed or slow. */
export function writeInMs (text, { reduced = false } = {}) {
  if (reduced) return 0
  const n = String(text || '').length
  return Math.round(Math.min(2800, Math.max(1100, n * 7)))
}

/**
 * The chips wait while the last card in the chat is a lesson's card drawn just
 * now whose reading is not written yet (a replay is written already).
 */
export function lessonChipsHeld (messages, written) {
  const list = Array.isArray(messages) ? messages : []
  for (let i = list.length - 1; i >= 0; i--) {
    const m = list[i]
    if (!m || m._context !== 'talk-card' || !m.talk_card) continue
    if (!m._live || !m.talk_card.lesson_draw) return false
    return !(written && written.has(m.talk_card.id))
  }
  return false
}

export function prefersReducedMotion () {
  try { return !!(typeof window !== 'undefined' && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) } catch (e) { return false }
}
